<template>
</template>

<script>
export default {
  name: "AgreementTerms"
}
</script>

<style scoped>

</style>
